import { Component, Output, EventEmitter } from '@angular/core';
import { NavController, ModalController } from 'ionic-angular';
import { ConfigService, LotteryService, SharedService, LottoBetpanelService } from 'baseline-lib';
import { BetslipPage } from '../betslip/betslip';
import { TranslateService } from '@ngx-translate/core';
import { Global } from '../../../global/global';
import { LoginModalPage } from '../../shared/login-modal/login-modal';
import { RegisterModalPage } from '../../shared/register-modal/register-modal';



/**
 * Generated class for the LotteryMenuComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'lottery-menu',
  templateUrl: 'lottery-menu.html'
})
export class LotteryMenuComponent {
  @Output() onclickevent: EventEmitter<any> = new EventEmitter<any>();
  
  lotteryGames: any =[];
  public _imageUrl : string;
  // private route: ActivatedRoute;
  sub: any;
  _gameList: any = [];
  dgid: number;
  selected : any;
  selected_header_id:number =0;
  showprofile : boolean = false;

  constructor(public navCtrl: NavController,private _configService: ConfigService,public modalCtrl : ModalController,
    public _lotteryService: LotteryService,public _sharedService: SharedService,public globalData:Global,
    public _lottoBetpanelService: LottoBetpanelService, public translate : TranslateService) 
  {
    console.log('Hello LotteryMenuComponent Component');
    this._imageUrl = this._configService.getImageUrl();
    console.log("The image URL IS" ,this._imageUrl)
  }

  ngOnInit() 
  {
    this._sharedService.toggle1 = false;
    this._sharedService.toggle = true;
    this._lotteryService.getGameListById(1)
      .subscribe(
        data => 
        {
          this._gameList = data.gli;
          if( data.gli)
          {
            this.lotteryGames = this._lotteryService.constructLottoGroups(data.gli);
            var firstGame : any;
            this._gameList.forEach(gameList => 
            {
              gameList.cgli.forEach(cg => 
              {
                if(cg.gstid == this.lotteryGames[0].gstid && !firstGame)
                {    
                  firstGame = cg;
                  this.selected = firstGame;
                  this._lotteryService.game= gameList;
                  this.performHeaderClick(this.lotteryGames[0].gstid);
                  this.onclickevent.emit(firstGame.gid);
                }
              });
            });
        }
      });
      setTimeout(() => {
        this._sharedService.hideLoader();
      }, 500);
  }

  openLotteryMenuPage()
  {
    this.showprofile = false;
    // this.ngOnInit();
  }

  openBetSlipPage()
 {   
   this.navCtrl.push(BetslipPage)
 }

//  loginClicked()
//   {
//     let profileModal = this.modalCtrl.create(LoginModalPage);
//     profileModal.present();    
//   }

//   registerClicked()
//   {
//     let registerModal = this.modalCtrl.create(RegisterModalPage);
//     registerModal.present();
//   }

  profileClicked(){
    if(this.showprofile){
      this.showprofile = false;
    }else{
      this.showprofile = true;
    }
  }


 performHeaderClick(gstid)
 {
  if(this.selected_header_id == gstid){
      this.selected_header_id = 0;
   }else{
     this.selected_header_id = gstid;
   }
    let self = this;
    if(self.selected != gstid)
    {
      console.log("The Selected Is ",this.selected);
      self.selected = gstid;
    }
 }

 performclick(gid, game)
 {
    this._sharedService.toggle1 = false;
    this._sharedService.toggle = true;
    this._lotteryService.game= game;
    console.log("Lottery Service game is ",gid);
    console.log(this._lotteryService.game);
    this.onclickevent.emit(gid);
    // this.navCtrl.push(LotteryDetailPage, {"game_id":gid });
 }
}



// WEBPACK FOOTER //
// ./src/app/lottery/lottery-menu/lottery-menu.ts